import { ReactElement } from 'react'
import { useTranslation } from 'react-i18next'
import { Space, Typography } from 'antd'

import { getShopifyBaseUrl } from 'src/utils/helper'

const GuideSection = (): ReactElement => {
  const { t } = useTranslation()
  const baseUrlShopify = getShopifyBaseUrl()
  return (
    <Space direction="vertical">
      <Typography.Title level={3}>
        {t('common:footer.sections.guide')}
      </Typography.Title>
      <a href={`${baseUrlShopify}/pages/find-frames-that-fit`}>
        {t('common:footer.guide.finding_frames')}
      </a>
      <a href={`${baseUrlShopify}/pages/understanding-your-prescription`}>
        {t('common:footer.guide.what_in_rx')}
      </a>
      <a href={`${baseUrlShopify}/pages/lenses-and-pricing`}>
        {t('common:footer.guide.lenses_pricing')}
      </a>
      <a href={`${baseUrlShopify}/pages/getting-your-order`}>
        {t('common:footer.guide.getting_order')}
      </a>
    </Space>
  )
}

export default GuideSection
